/**
 * Two-Up Component
 */
import '@js/common/lottie.min.js';

const getBodymovin = () => {
	if (typeof window !== 'undefined') {
		if (window.bodymovin && typeof window.bodymovin.loadAnimation === 'function') return window.bodymovin;
		if (window.lottie && typeof window.lottie.loadAnimation === 'function') return window.lottie;
	}
	return null;
};

export const initTwoUpComponent = () => {
	const components = document.querySelectorAll('.two-up-component');
	if (!components.length) return;

	const bodymovin = getBodymovin();
	if (!bodymovin) {
		return;
	}

	if (typeof window !== 'undefined') {
		window.bodymovin = window.bodymovin || bodymovin;
		window.lottie = window.lottie || bodymovin;
	}

	components.forEach((component) => {
		const cols = component.querySelectorAll('.tuc-col');
		if (!cols.length) return;

		cols.forEach((col) => {
			const animElement = col.querySelector('.tuc-bg-animation');
			if (!animElement || animElement.dataset.lottieInitialized === 'true') return;

			const dataJson = animElement.getAttribute('data-json');
			if (!dataJson) return;

			animElement.dataset.lottieInitialized = 'true';

			let animationInstance = null;
			try {
				animationInstance = bodymovin.loadAnimation({
					container: animElement,
					path: dataJson,
					renderer: 'canvas',
					loop: false,
					autoplay: false,
					rendererSettings: {
						preserveAspectRatio: 'xMaxYMid slice',
						clearCanvas: true,
					},
				});
			} catch (e) {
				try {
					animationInstance = bodymovin.loadAnimation({
						container: animElement,
						path: dataJson,
						renderer: 'svg',
						loop: false,
						autoplay: false,
						rendererSettings: {
							preserveAspectRatio: 'xMaxYMid slice',
						},
					});
				} catch (err) {
					return;
				}
			}

			const playAnimationOnHover = () => {
				if (!animationInstance) return;

				if (animationInstance.isLoaded) {
					animationInstance.goToAndPlay(0, true);
				} else {
					animationInstance.addEventListener(
						'DOMLoaded',
						() => {
							animationInstance.goToAndPlay(0, true);
						},
						{ once: true }
					);
				}
			};

			col.addEventListener('mouseenter', playAnimationOnHover);
		});
	});
};

// Initialize on DOMContentLoaded or immediately if ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initTwoUpComponent);
} else {
	initTwoUpComponent();
}

window.addEventListener('load', initTwoUpComponent);

// ACF Gutenberg block preview support
if (typeof window !== 'undefined' && window.acf) {
	window.acf.addAction(
		'render_block_preview/type=two-up-component',
		initTwoUpComponent
	);
}

export default initTwoUpComponent;
